import { Injectable } from '@angular/core';
import { DataContextService, ResultWrapper } from '@seahorse/common';
import { Observable } from 'rxjs';
import {
  OrganisationModel,
  OrganisationOwnerModel,
} from '../models/organisation.model';
import { DataService } from '../../shared/services/data.service';

@Injectable({
  providedIn: 'root',
})
export class OrganisationsDataService
  implements DataService<OrganisationModel>
{
  constructor(private dataContext: DataContextService) {}

  searchOrganisations(
    searchQuery?: string,
    pageIndex?: number,
    pageSize?: number,
    showInactive: boolean = false,
    sortField: string = 'CreatedOn'
  ): Observable<ResultWrapper<OrganisationModel[]>> {
    const queryParams = [
      `showInactive=${showInactive}`,
      `sortfield=${sortField}`,
    ];

    if (searchQuery !== undefined && searchQuery !== null) {
      queryParams.push(`searchTerm=${encodeURIComponent(searchQuery)}`);
    }

    if (pageIndex !== undefined && pageIndex !== null) {
      queryParams.push(`pindex=${pageIndex}`);
    }

    if (pageSize !== undefined && pageSize !== null) {
      queryParams.push(`psize=${pageSize}`);
    }

    const queryString = queryParams.join('&');
    const url = `organisations/search?${queryString}`;

    return this.dataContext.get<OrganisationModel[]>(url);
  }

  getOrganisation(id: string): Observable<ResultWrapper<OrganisationModel>> {
    return this.dataContext.get<OrganisationModel>(`organisations/${id}`);
  }

  getOrganisations(): Observable<ResultWrapper<OrganisationModel[]>> {
    return this.dataContext.get<OrganisationModel[]>(`organisations`);
  }

  add(model: OrganisationModel): Observable<ResultWrapper<OrganisationModel>> {
    return this.dataContext.post<OrganisationModel>(`organisations`, model);
  }

  update(
    model: OrganisationModel
  ): Observable<ResultWrapper<OrganisationModel>> {
    return this.dataContext.put<OrganisationModel>(
      `organisations/${model.id}`,
      model
    );
  }

  addOrganisationOwner(
    model: OrganisationOwnerModel
  ): Observable<ResultWrapper<OrganisationOwnerModel>> {
    return this.dataContext.post<OrganisationOwnerModel>(
      `organisations/owner`,
      model
    );
  }

  updateOrganisationOwner(
    model: OrganisationOwnerModel
  ): Observable<ResultWrapper<OrganisationOwnerModel>> {
    return this.dataContext.put<OrganisationOwnerModel>(
      `organisations/owner/${model.organisationId}`,
      model
    );
  }

  delete(
    accountId: OrganisationModel['id']
  ): Observable<ResultWrapper<OrganisationModel>> {
    return this.dataContext.delete<OrganisationModel>(
      `organisations/${accountId}`
    );
  }

  getById(id: number): Observable<ResultWrapper<OrganisationModel>> {
    throw new Error('Method not implemented.');
  }
}
